import { z } from 'zod';

import { WayfinderJson } from '../models';
import { BasePType } from './base';

export const Wayfinder = BasePType.extend({
  type: z.enum(['wayfinderMatrix']),
  wayfinderMatrixJson: z.array(WayfinderJson).nullable(),
});

export type Wayfinder = z.infer<typeof Wayfinder>;
